import React from 'react';
import config from '../../../config';

const UTMap = (props) => {
    const { lat, lng, placeId, placeName, height } = props;
    const placeParam = placeId ? `q=place_id:${placeId}` : placeName ? `q=${encodeURI(placeName)}` : `q=${lat},${lng}`;
    const placeUrl = `https://www.google.com/maps/embed/v1/place?key=${config.googleApiKey}&${placeParam}`;
    const mapheight = height || `216px`;
    return (
        <iframe
            width="100%"
            height={mapheight}
            frameBorder="0"
            src={placeUrl}
        />
    );
};

export default UTMap;
